var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col p-1" }, [
      _c("label", [
        _vm._v("Sollwert Silo " + _vm._s(_vm.targetSiloNumber) + " ")
      ]),
      _c("div", { staticClass: "input-group input-group-sm" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.number",
              value: _vm.targetPercentage,
              expression: "targetPercentage",
              modifiers: { number: true }
            }
          ],
          staticClass: "form-control",
          attrs: {
            type: "number",
            min: 1,
            max: 100,
            disabled: _vm.loading || _vm.transferClearanceBitSet
          },
          domProps: { value: _vm.targetPercentage },
          on: {
            click: function($event) {
              $event.stopPropagation()
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.targetPercentage = _vm._n($event.target.value)
            },
            blur: function($event) {
              return _vm.$forceUpdate()
            }
          }
        }),
        _c(
          "div",
          {
            staticClass: "input-group-append",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [_c("span", { staticClass: "input-group-text" }, [_vm._v("%")])]
        )
      ])
    ]),
    _c("div", { staticClass: "col p-1" }, [
      _c(
        "button",
        {
          class: [
            "btn",
            _vm.success == true ? "btn-primary" : "btn-secondary",
            "w-100",
            "silo-transfer-button"
          ],
          attrs: { disabled: _vm.loading || _vm.transferClearanceBitSet },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.sendTransferSign.apply(null, arguments)
            }
          }
        },
        [
          _vm.loading
            ? _c("em", { staticClass: "fas fa-spinner fa-spin me-1" })
            : _vm.success === true
            ? _c("em", { staticClass: "fas fa-check me-1 bounce" })
            : _vm.success === false
            ? _c("em", { staticClass: "fas fa-times me-1 bounce" })
            : _c("span", [
                _vm._v("Umblasen zu Silo " + _vm._s(_vm.targetSiloNumber))
              ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }